<nav class="navbar navbar-expand navbar-light bg-dark-style static-top osahan-nav sticky-top">
        &nbsp;&nbsp;
        <button (click)="toggleMenu()" *ngIf="menuclosed" class="btn btn-link btn-sm text-secondary order-0 order-sm-0" id="sidebarToggle">
            <i class="fas fa-bars"></i>
        </button>
        <button (click)="toggleMenu()" *ngIf="!menuclosed" class="btn btn-link btn-sm text-secondary order-0 order-sm-0" id="sidebarToggle">
                <i class="fas fa-times"></i>
            </button> &nbsp;&nbsp;
        <a class="navbar-brand mr-1" routerLink="/">
            <img class="img-fluid" alt="" src="assets/img/hostbrand/core-logo.svg" width="205">
        </a>
     <form (ngSubmit)='siteSearch()' class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-5 my-2 my-md-0 osahan-navbar-search">
            <!-- <div class="input-group">
                <input (keyup)="onSiteSearchKeyUp($event)" type="text" class="form-control" placeholder="Search for..." i18n-placeholder="From placeholder" value="Search for..." #searchInput>
                <div class="input-group-append">
                    <button class="btn btn-light" type="submit">
                        <i class="fas fa-search"></i>
                    </button>
                </div>
            </div> -->
        </form>

        <ul class="navbar-nav ml-auto ml-md-0 osahan-right-navbar">
            <!-- <li class="search-nav nav-item dropdown no-arrow mx-1"><a data-toggle="modal" data-target="#mobSearch" class="nav-link" id="alertsDropdown" role="button"
                    aria-haspopup="true" routerLink="javascript;" aria-expanded="false">
                    <i class="fas fa-search fa-fw"></i>
                    </a>
            </li> -->
            <li *ngIf="notificationLength > 0" class="nav-item dropdown no-arrow mx-1">
                <a href="#"  (click)="clearNotifications()" class="nav-link dropdown-toggle"  id="alertsDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-bell fa-fw"></i>
                    <span class="badge badge-danger" *ngIf="notificationLength > 0">{{notificationLength}}</span>
                </a>
                <div  class="dropdown-menu dropdown-menu-right" aria-labelledby="alertsDropdown">
                    <span *ngFor="let message of notification let i=index;">
                        <span *ngIf="message.type != 'CELEBRATION'">
                        <a href="#" *ngIf="message.notificationNoted == true" class="messageSeen dropdown-item" (click)="clearNotification([message.id])" (click)="messageIndex = i"
                            data-toggle="modal" data-target="#logoutModal" >
                            <i class="fas fa-fw fa-star "></i> &nbsp; {{message.title}}</a>
                        <a href="#" *ngIf="message.notificationNoted == false" class="messageUnseen dropdown-item" (click)="clearNotification([message.id])" (click)="messageIndex = i"
                            data-toggle="modal" data-target="#logoutModal"  >
                            <i class="fas fa-fw fa-star "></i> &nbsp; {{message.title}}</a>
                        <div class="dropdown-divider"></div>
                    </span>
                    </span>
                </div>
            </li>
            <li *ngIf="!isWoohoo && qualityName == 'block'" class="nav-item dropdown no-arrow mx-1">
                <a class="nav-link dropdown-toggle" href="#"  id="messagesDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <i class="fas fa-video fa-fw"></i><span> {{qualityName}}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="messagesDropdown">
                    <a i18n="@@240p | Site Quality Setting" (click)="onMobile()" class="dropdown-item" >240p</a>
                    <a i18n="@@360p | Site Quality Setting" (click)="onTablet()" class="dropdown-item" >360p</a>
                    <a i18n="@@480p | Site Quality Setting"(click)="onDesktop()" class="dropdown-item" >480p</a>
                    <a i18n="@@720p | Site Quality Setting" (click)="onIntrinsic()" class="dropdown-item">720p</a>
                    <a i18n="@@1080p | Site Quality Setting" (click)="onIntrinsic()" class="dropdown-item">1080p</a>
                </div>
            </li>
            <!-- <li class="nav-item dropdown no-arrow mx-1">
                <a class="nav-link dropdown-toggle" href="#"  id="messagesDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <i class="fas fa-globe fa-fw"></i><span i18n="@@Langauge | Langauge Dropdown Title">Language</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="messagesDropdown">
                    <a class="dropdown-item" href="/">English</a>
                    <ng-container *ngFor="let language of languageList"> <a class="dropdown-item" href="/{{language.code}}/">{{language.label}}</a></ng-container>
                </div>
            </li> -->
            <li class="nav-item dropdown no-arrow osahan-right-navbar-user">
                <a class="nav-link dropdown-toggle user-dropdown-link" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <i class="fas fa-user fa-fw"></i> {{profileData.phoneNumber}}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                    <a i18n="@@My Account | My Account Dropdown Title" class="dropdown-item" routerLink="/account">
                        <i class="fas fa-fw fa-user-circle"></i> &nbsp; My Account</a>
                    <a i18n="@@My Channels | My Channels Dropdown Title" class="dropdown-item" routerLink="/channels">
                        <i class="fas fa-fw fa-video"></i> &nbsp; Explore Channels</a>
                        <a i18n="@@Terms and Conditions | Terms and Conditions Dropdown" class="dropdown-item" href="{{terms}}" target="_blank">
                            <i class="fas fa-fw fa-info"></i> &nbsp; Terms and Conditions</a>
                            <a  style="cursor: pointer;" class="dropdown-item" (click)="confettiGun()"><i class="fas fa-fw fa-gift"></i><span i18n="@@Party Time | Party Time Link">Party Time</span></a>
                    <div class="dropdown-divider"></div>
                    <!-- <a i18n="@@Logout | Logout Button" class="dropdown-item" routerLink="/kidstubeut">
                        <i class="fas fa-fw fa-sign-out-alt"></i> &nbsp; Logout</a> -->
                </div>
            </li>
            <li *ngIf="isWoohoo && totalEntries > 0" class="nav-item dropdown no-arrow mx-1">
                    <a href="#" class="woohooEntries nav-link" id="messagesDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false" data-toggle="modal" data-target="#woohooModal">
                        <i class="fas fa-star fa-fw"></i><span class="pulsate"> {{totalEntries}} Daily Entries</span>
                    </a>
                </li>
        </ul>
    </nav>
    <div *ngIf="isWoohoo && totalEntries > 0" class="woohooEntriesMobile" href="#" id="messagesDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
    aria-expanded="false" data-toggle="modal" data-target="#woohooModal">
        <i class="fas fa-star fa-fw"></i><span class="pulsate"> {{totalEntries}} Daily Entries</span>
    </div>
    <!-- Logout Modal-->
    <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 *ngIf="notification[messageIndex] != null" class="modal-title" id="exampleModalLabel">
                        {{notification[messageIndex].title}}
                    </h5>
                    <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div *ngIf="notification[messageIndex] != null" class="modal-body"> {{notification[messageIndex].description}} </div>
                <div class="modal-footer">
                    <a i18n="@@Mark As Seen | Mark Notification as seen" data-dismiss="modal" class="btn btn-primary">Mark as Seen</a>
                </div>
            </div>
        </div>
    </div>
    <!-- Woohoo How it Works Modal-->
    <div class="modal fade" id="woohooModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div class="modal-content">
                   
                        <div class="modal-body howToWinBox">
                                <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                 <div style="padding: 40px;" class="row">
                                        <img class="howtoWinDesk" style="width: 100%;" src='assets/img/howtowin.png' />
                                        <img class="howtoWinMobile" style="width: 100%;" src='assets/img/howtowinmobile.png' />
                               
<button data-dismiss="modal" aria-label="Close" routerLink="/" type="button" class="form-control">
        <span>Play Now</span>
      </button>
                </div>
            </div>
        </div>
    <ngx-smart-modal #errorModal identifier="errorModal">
            <h1>Oh no!</h1>
            <p>Something went wrong, please refresh page</p>
          </ngx-smart-modal>
          <span *ngFor="let message of celebrationMessages let i=index; last as final">
          <span *ngIf="final && message.type == 'CELEBRATION' && confettiGunReady && !message.notificationNoted"> 
                <div id="overlay">
                        <div id="text">{{message.title}} Entries</div>
                        <span *ngIf="confettiGunLoaded">
                                {{confettiGun()}}
                                {{clearNotification([message.id])}}
                                {{clearNotifications()}}
                               
                        </span>
                        
                      </div>
        </span>
        </span>
      
         
                    